// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import isApiError from "@insite/client-framework/Common/isApiError";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";

const useHandleApiError = () => {
    const appDispatch = useAppDispatch();

    const signInUrl = useAppSelector(state => getPageLinkByPageType(state, "SignInPage")?.url) || "SignIn";
    let currentLocation: Location | undefined;
    if (typeof window !== "undefined") {
        currentLocation = window?.location;
    }

    const history = useHistory();
    return async <T>(
        callback: () => Promise<T>,
        optionalErrorCallback?: (error: Error) => void,
    ): Promise<T | never> => {
        const errorCallback =
            optionalErrorCallback ||
            (() => appDispatch({ type: "Context/SetErrorModalIsOpen", isErrorModalOpen: true }));
        try {
            const response = await callback();
            return response;
        } catch (error) {
            if (error instanceof Error) {
                if (isApiError(error) && (error.status === 401 || error.status === 403)) {
                    history.push(`${signInUrl}?returnUrl=${currentLocation?.pathname ?? ""}${window.location.search}`);
                } else {
                    errorCallback(error);
                }
            }
            throw error;
        }
    };
};

export default useHandleApiError;
